







































































































































































































import '../../styles/goods-details.less'
import router from '@/router'
import { Component, Vue, Watch } from 'vue-property-decorator'
import Recommend from '@/components/public/Recommend.vue'
import detailsApi from '@/api/detailsApi'
import listApi from '@/api/listApi'
import SelfModal from '@/components/public/SelfModal.vue'
import ShowImg from '@/components/ui/ShowImg.vue'
import ZoomImg from '@/components/ui/ZoomImg.vue'
@Component({
  components: {
    Recommend,
    SelfModal,
    ShowImg,
    ZoomImg
  }
})
export default class GoodsDetails extends Vue {

  private goodsId: string = ''
  // private step: string = '1'
  private nav: boolean = false
  private toType: number = 1
  private id: number = 0
  private visible: boolean = false
  private goodsDetails: object = {}
  private boutiqueList: any[] = [

  ]
  // private showModal: boolean = false

  @Watch('$route')
  public watchRouter(router: any) {
    if (router.query.id) {
      this.getDetails()
    }
  }

  public mounted(): void {
    // window.addEventListener('scroll', this.getScroll)
    this.getBoutique()
    this.getDetails()
  }

  public destroyed(): void {
    // window.removeEventListener('scroll', this.getScroll)
  }


  // 获取详细信息
  protected getDetails(): void {
    detailsApi.getDetails({
      id: this.$route.query.id,
      type: this.$route.query.carts || ''
    }).then((res) => {
      if (res.code === 200) {
        this.goodsDetails = res.data
      } else {
        this.$message.warning(res.msg)
      }
    })
  }

  // 右边资源精选
  protected getBoutique(): void {
    listApi.getHotList({
      businessType: 'PROMOTION',
      position: 'GOODS_DETALIS_BOTTOM',
    }).then((res) => {
      if (res.code === 200 && res.data.length > 0) {
        this.boutiqueList = res.data
        console.log(res.data)
      }
    })
  }

  // 下单
  protected buy() {
    const currentUser: any = this.$store.state.user.current;
    // 判断当前账户状态
    if (currentUser.status == 'ENABLE') {
      if ((this.goodsDetails as any).purchasedStatus === 'SELL_OUT') {
        return
      }
      // let step = '1'
      const resourceId = (this.goodsDetails as any).resourceId
      detailsApi.buy({
        id: resourceId
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.code === 1) {
            sessionStorage.setItem('uniqueKey',res.data.uniqueKey)
            router.push({
              name: 'buy',
              query: { step: '1', id: resourceId, stepStatus: '1', tradeSize: (this.goodsDetails as any).tradeSize}
            });
          } else if (res.data.code === 262538) {
            sessionStorage.setItem('uniqueKey',res.data.uniqueKey)
            router.push({
              name: 'buy',
              query: { step: '2', id: resourceId, stepStatus: '2', tradeSize: (this.goodsDetails as any).tradeSize }
            });
          } else if (res.data.code === 262509) {
            this.$warning({
              title: '下单失败',
              content: '当前资源已关联' + res.data.msg + '仅限已购买该资源的供应商购买',
              okText: '知道了'
            });
          } else if (res.data.code === 262510) {
            this.$warning({
              title: '下单失败',
              content: '当前资源已绑定' + res.data.msg + '，仅限已发布' + res.data.msg + '类商品的供应商购买',
              okText: '知道了'
            });
          } else if (res.data.code === 262511) {
            this.$warning({
              title: '下单失败',
              content: '当前资源已关联' + res.data.msg + '品类，仅限已发布' + res.data.msg + '品类商品的供应商购买',
              okText: '知道了'
            });
          } else if (res.data.code === 262512) {
            this.$warning({
              title: '下单失败',
              content: '当前资源已关联' + res.data.msg + '仅限已发布' + res.data.msg + '商品的供应商购买',
              okText: '知道了'
            });
          } else {
            this.$warning({
              title: '下单失败',
              content: res.data.msg,
              okText: '知道了'
            });
          }
        }
      })
    } else {
      this.$warning({
        title: '警告',
        content: '当前账号资质已过期，请完善资质后进行操作',
        okText: '知道了'
      });
    }
  }

  // 跳转位置
  protected goPosition(type: number) {
    this.toType = type
    let scroll = document.documentElement.scrollTop
    let goIntroduce = document.getElementById('goIntroduce').offsetTop
    let goImg = document.getElementById('goImg').offsetTop
    if (this.toType === 1) {
      document.body.scrollTop = goIntroduce - 150
      document.documentElement.scrollTop = goIntroduce - 150
    } else {
      document.body.scrollTop = goImg - 50
      document.documentElement.scrollTop = goImg - 50
    }
  }

  // 点击图片
  protected imgShow() {
    // this.showModal = true
  }


  // protected getScroll() {
  //   const topScroll = window.pageYOffset
  //   const exhibitionTop = document.querySelector('#exhibitionTop').offsetTop
  //   if (topScroll > exhibitionTop) {
  //     this.nav = true
  //   } else {
  //     this.nav = false
  //   }
  // }
}
